import { createLogger } from '@/utils/logger';

const consoleLogger = createLogger();

export default (_, inject) => inject('logger', consoleLogger);
